import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiDataDup } from "../../../redux/reducers/commonApiSlice";
import { fd_task_sop } from "../../../data/ApiEndpoints";
import CmnFilters from "../common/CmnFilters";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertThenFormat,
  currentDateOfTheMonth,
  currentMonthEndDate,
  currentMonthStartDate,
} from "../../common-data/Converts";
import AgentReportMobileCard from "../agent-report/agentReportMobileCard";

const FDTaskSop = ({ userInfoData, prevAllFilters, rowData }) => {
  const dispatch = useDispatch();
  const { dataDup, loading: loadingDup } = useSelector((state) => state.common);

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: rowData?.gym_id
      ? {
          label: rowData?.gym_name || "",
          value: rowData?.gym_id || "",
        }
      : !isAdmin && !isMarketing && !isClusterManager
      ? {
          label: userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedFd:
      !isAdmin && !isClusterManager
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    selectedStartDate: prevAllFilters?.selectedStartDate
      ? prevAllFilters.selectedStartDate
      : currentMonthStartDate,
    selectedEndDate: prevAllFilters?.selectedEndDate
      ? prevAllFilters.selectedEndDate
      : currentMonthEndDate,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1 || 1,
    limit: pageLimit || 10,
    gym_id: rowData?.gym_id || "",
    user_id: allFilters.selectedFd?.value || "",
    start_date: allFilters?.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniAllData = {
    allDatas: [],
    pagination: [],
  };
  const [allData, setAllData] = useState(iniAllData);

  const { selectedStartDate, selectedEndDate } = allFilters || {};
  const startDate = selectedStartDate
    ? convertStraight(selectedStartDate)
    : "-";
  const endDate = selectedEndDate ? convertStraight(selectedEndDate) : "-";

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  }

  function getFDTaskSop(filters) {
    dispatch(
      fetchApiDataDup({
        method: "GET",
        endpoint: fd_task_sop,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: rowData?.gym_id || "",
    }));

    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: rowData?.gym_id
        ? {
            label: rowData?.gym_name || "",
            value: rowData?.gym_id || "",
          }
        : !isAdmin
        ? {
            label: userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [rowData?.gym_id, rowData?.gym_name, userInfoData?.gym_id]);

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedStartDate: prevAllFilters?.selectedStartDate
        ? prevAllFilters.selectedStartDate
        : currentMonthStartDate,
      selectedEndDate: prevAllFilters?.selectedEndDate
        ? prevAllFilters.selectedEndDate
        : currentMonthEndDate,
    }));
  }, [prevAllFilters?.selectedStartDate, prevAllFilters?.selectedEndDate]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1 || 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      user_id: allFilters.selectedFd?.value || "",
      start_date: allFilters?.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
    }));
  }, [allFilters]);

  useEffect(() => {
    if (filters.gym_id) {
      getFDTaskSop(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (dataDup?.status && dataDup?.data) {
      setAllData((prevs) => ({
        ...prevs,
        allDatas: dataDup?.data || [],
        pagination: dataDup?.pagination || [],
      }));
    } else {
      setAllData(iniAllData);
    }
  }, [dataDup]);

  const fdSopTbColumns = [
    {
      dataField: "user_id",
      text: <p className="table__header">fd info</p>,
      formatter: (_, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.name || "NA"}
            <br />
            <small className="lowercase">
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </p>
        );
      },
    },
    {
      dataField: "this_month_total_unpaid",
      text: (
        <p className="table__header">
          this month total unpaid ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_total_unpaid ? row?.this_month_total_unpaid : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_unpaid_added_to_lead",
      text: (
        <p className="table__header">
          this month unpaid added to lead ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_unpaid_added_to_lead
              ? row?.this_month_unpaid_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_unpaid_today_followup",
      text: (
        <p className="table__header">
          this month unpaid today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_unpaid_today_followup
              ? row?.this_month_unpaid_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_total_unpaid",
      text: <p className="table__header">sixty days total unpaid</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_total_unpaid ? row?.sixty_days_total_unpaid : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_added_to_lead",
      text: <p className="table__header">sixty days unpaid added to lead</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_added_to_lead
              ? row?.sixty_days_unpaid_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_not_added_to_lead",
      text: (
        <p className="table__header">sixty days unpaid not added to lead</p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_not_added_to_lead
              ? row?.sixty_days_unpaid_not_added_to_lead
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sixty_days_unpaid_today_followup",
      text: (
        <p className="table__header">
          sixty days unpaid today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sixty_days_unpaid_today_followup
              ? row?.sixty_days_unpaid_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "this_month_missed_interested_followup",
      text: (
        <p className="table__header">
          this month missed interested follow up ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.this_month_missed_interested_followup
              ? row?.this_month_missed_interested_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "today_followup_added",
      text: (
        <p className="table__header">
          today follow up added ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.today_followup_added ? row?.today_followup_added : 0}
          </p>
        );
      },
    },
    {
      dataField: "advancerenew_this_month",
      text: (
        <p className="table__header">
          advance renewel this month ({startDate}/{endDate})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.advancerenew_this_month ? row?.advancerenew_this_month : 0}
          </p>
        );
      },
    },
    {
      dataField: "advancerenew_today_followup",
      text: (
        <p className="table__header">
          advance renewel today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.advancerenew_today_followup
              ? row?.advancerenew_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "expt_today",
      text: (
        <p className="table__header">
          expiry today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.expt_today ? row?.expt_today : 0}
          </p>
        );
      },
    },
    {
      dataField: "expt_today_followup",
      text: (
        <p className="table__header">
          expiry today follow up ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.expt_today_followup ? row?.expt_today_followup : 0}
          </p>
        );
      },
    },
    {
      dataField: "rawlead_assigned_today",
      text: (
        <p className="table__header">
          raw lead assigned today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.rawlead_assigned_today ? row?.rawlead_assigned_today : 0}
          </p>
        );
      },
    },
    {
      dataField: "rawlead_assigned_today_followup",
      text: (
        <p className="table__header">
          raw lead assigned today follow up (
          {convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.rawlead_assigned_today_followup
              ? row?.rawlead_assigned_today_followup
              : 0}
          </p>
        );
      },
    },
    {
      dataField: "sales_target_today",
      text: (
        <p className="table__header">
          sales target today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {`₹${convertThenFormat(row?.sales_target_today || 0)}`}
          </p>
        );
      },
    },
    {
      dataField: "sales_completed_today",
      text: (
        <p className="table__header">
          sales completed today ({convertStraight(currentDateOfTheMonth)})
        </p>
      ),
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
            }}
          >
            {row?.sales_completed_today
              ? `₹${convertThenFormat(row?.sales_completed_today)}`
              : 0}
          </p>
        );
      },
    },
  ];

  return (
    <>
      <CmnFilters
        from={"fd-task-sop"}
        filters={allFilters}
        setFilters={setAllFilters}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
        {loadingDup ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allData.allDatas}
            tableColumns={fdSopTbColumns}
            isFirstColSticky={true}
            tablePagination={allData.pagination}
            setIsPage={setIsPage}
            isPage={isPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loadingDup ? (
          <ReactVortoxSpinner />
        ) : (
          <AgentReportMobileCard
            tableData={allData.allDatas}
            tablePagination={allData.pagination}
            type="fdsop"
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default FDTaskSop;
